<template>
  <div
    class="set-password-notification"
    :class="isClientCabinet ? 'set-password-notification--client' : ''">
    <template v-if="!isClientCabinet">
      <div class="set-password-notification__body">
        <span class="set-password-notification__img">
          🔐
        </span>

        <p class="set-password-notification__text">
          Create a password to access your account features
        </p>
      </div>

      <button
        class="button button-additional set-password-notification__button"
        @click="$emit('set-password')">
        Create new password
      </button>
    </template>

    <template v-else>
      <div
        class="set-password-notification__body set-password-notification__body--client"
        @click="$emit('set-password')">
        <span class="set-password-notification__img set-password-notification__img--client">
          🔑
        </span>

        <p class="set-password-notification__text set-password-notification__text--client">
          Create a password to access your account features
        </p>
      </div>

      <button
        class="button button-additional-gradient
        set-password-notification__button set-password-notification__button--client"
        @click="$emit('set-password')">
        Create new password
      </button>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SetPasswordNotification',

  computed: {
    isClientCabinet() {
      return this.$route.path.match('/client');
    },
  },
};
</script>

<style lang="scss" scoped>
  .set-password-notification {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: sticky;
    top: 0;
    left: 0;
    width: 100%;
    padding: 20px 5% 25px;
    background-color: $color--basic-menu;
    z-index: #{$z-index-intercom + 1};
  }

  .set-password-notification--client {
    background-color: rgba($color--basic-blue, 0.25);
    padding: 8px 16px 0;
    height: 46px;
  }

  .set-password-notification__body {
    display: flex;
    align-items: center;
  }

  .set-password-notification__body--client {
    cursor: pointer;
  }

  .set-password-notification__img {
    display: none;
    font-size: 25px;
    line-height: 1;
  }

  .set-password-notification__img--client {
    display: block;
  }

  .set-password-notification__text {
    padding: 0 16px;
    text-align: center;
    color: $color--basic-white;
    font-size: 11px;
    font-weight: 500;
  }

  .set-password-notification__text--client {
    text-align: left;
    font-size: 13px;
  }

  .set-password-notification__button {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    width: 100%;
    font-size: 13px;
    text-transform: none;
    margin-top: 16px;
  }

  .set-password-notification__button--client {
    display: none;
  }

  @media screen and #{$screen-more-or-768} {
    .set-password-notification {
      flex-direction: row;
      justify-content: center;
      padding: 0 55px;
      height: 45px;
      bottom: 19px;
    }

    .set-password-notification--client {
      padding: 0 68px;
      height: 72px;
    }

    .set-password-notification {
      margin-bottom: 0;
      align-items: center;
    }

    .set-password-notification__img {
      display: block;
    }

    .set-password-notification__text {
      font-size: 13px;
      padding: 0 12px 0 16px;
    }

    .set-password-notification__text--client {
      padding: 0 0 0 16px;
      font-size: 15px;
    }

    .set-password-notification__button {
      height: 32px;
      border-radius: 100px;
      padding: 0 16px;
      width: max-content;
      margin-top: 0;
    }

    .set-password-notification__button--client {
      display: block;
      height: 40px;
      padding: 12px;
      text-transform: uppercase;
      border-radius: 4px;
    }

    .set-password-notification__body--client {
      margin-right: 32px;
    }
  }
</style>
